import Organisation from '@/models/Organisation';
import { IOrganisationState } from '@/modules/organisation/store/state';
import { IRootState } from '@/store/state';
import { Getter, GetterTree } from 'vuex';
import { OrganisationUser } from '../types';

/**
 * --------------------------------------------------
 *	Organisation Getters
 * --------------------------------------------------
 **/
export const OrganisationGetters: IOrganisationGetters = {
  organisation: (state: IOrganisationState): Organisation | undefined =>
    state.organisation,
  enableDownloads: (state: IOrganisationState): boolean =>
    !state.organisation?.platformOrgConfig?.config?.disable_downloads,
  showChartsPage: (state: IOrganisationState): boolean =>
    state.organisation?.platformOrgConfig?.config?.show_charts_page,
  orgNavbar: (state: IOrganisationState): boolean => state.orgNavbar,
  organisationUser: (state: IOrganisationState): OrganisationUser =>
    state.organisationUser,
  loader: (state: IOrganisationState): boolean => state.loader
};

/**
 * --------------------------------------------------
 *	Organisation Getters Interface
 * --------------------------------------------------
 **/
export interface IOrganisationGetters
  extends GetterTree<IOrganisationState, IRootState> {
  organisation: Getter<IOrganisationState, IRootState>;
  orgNavbar: Getter<IOrganisationState, IRootState>;
  organisationUser(state: IOrganisationState): OrganisationUser;
  loader(state: IOrganisationState): boolean;
}
